
import ResearchGroupRepositoryAPI from "@/modules/research-group/research-group-repository-api";
import UserRepositoryAPI from "@/modules/user/user-repository-api";
import axios from "@/services/axios";
import { lazyParamsDefault } from "@/utils/pagination-helper";
import { FilterMatchMode } from "primevue/api";
import { computed, defineComponent, onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  setup() {
    const { t } = useI18n();
    const filters = reactive({
      name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const { setResearchGroup, loadItems } = ResearchGroupRepositoryAPI();

    const state = reactive({
      users: [],
      selectedRow: [],
      editingRows: [],
      dataLoading: true,
      researchGroup: [] as Array<any>,
      lazyParams: lazyParamsDefault,
      keywords: "",
    });

    const onRowSelect = (event: any): void => {
      setResearchGroup(event.data);
    };

    const onPaginatorResearchGroupClick = (event: any): void => {
      state.lazyParams = event;
      loadItems(state);
    };

    async function loadUsers() {
      const response = await axios.get("api/v1/User?PageNumber=0&PageSize=500");
      state.users = response.data;
    }

    const onSearchKeywordClick = (): void => {
      state.lazyParams.page = 0;
      if (state.keywords.length > 1 || state.keywords.length == 0) {
        onPaginatorResearchGroupClick(state.lazyParams);
        return;
      }
    };

    onMounted(() => {
      loadUsers();
      onPaginatorResearchGroupClick(state.lazyParams);
    });

    return {
      t,
      onRowSelect,
      filters,
      state: computed(() => state),
      onPaginatorResearchGroupClick,
      onSearchKeywordClick,
    };
  },
});
